import { render, staticRenderFns } from "./SchoolAssessment.vue?vue&type=template&id=34e654ce"
import script from "./SchoolAssessment.vue?vue&type=script&lang=js"
export * from "./SchoolAssessment.vue?vue&type=script&lang=js"
import style0 from "./SchoolAssessment.vue?vue&type=style&index=0&id=34e654ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports